import {
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { Fragment } from "react";
import { I18nTranslator, translations } from "utils/i18n";

export enum ECommonDialogType {
  NORMAL,
  SUCCESS,
  WARNING,
  ERROR,
}
interface ICommonDialogProps {}
interface ICommonDialogState {
  open: boolean;
  type: ECommonDialogType;
  buttons: IDialogButtonProps[];
  title: string;
  message: string;
  disableCancel?: boolean;
  component?: JSX.Element;
}
export interface IDialogArg {
  title: string;
  type: ECommonDialogType;
  component?: JSX.Element;
  message?: string;
  buttons?: IDialogButtonProps[];
  disableCancel?: boolean;
  onClose?(): void;
}
export interface IDialogButtonProps {
  title: string;
  isCancel?: boolean;
  onClick?(): void;
  buttonProps?: ButtonProps;
}
class CommonDialogManager {
  _defaultAlert: CommonDialog | null = null;
  register(_ref: CommonDialog) {
    this._defaultAlert = _ref;
  }
  unregister(_ref: CommonDialog) {
    this._defaultAlert = null;
  }
  getDefault() {
    return this._defaultAlert;
  }
}

const commonDialogManager = new CommonDialogManager();
export function openDialog(arg: IDialogArg) {
  const ref = commonDialogManager.getDefault();
  if (ref) {
    ref.openDialog(arg);
  }
}

export function closeDialog(onClose?: () => void) {
  const ref = commonDialogManager.getDefault();
  if (ref) {
    ref.closeDialog(() => {
      if (onClose) {
        onClose();
      }
    });
  }
}

const _getType = (type: ECommonDialogType) => {
  switch (type) {
    case ECommonDialogType.NORMAL:
      return {
        color: "primary",
      };
    case ECommonDialogType.SUCCESS:
      return {
        color: "success",
      };
    case ECommonDialogType.WARNING:
      return {
        color: "#d90000",
      };
    case ECommonDialogType.ERROR:
      return {
        color: "error",
      };
  }
};

export default class CommonDialog extends React.Component<
  ICommonDialogProps,
  ICommonDialogState
> {
  state: ICommonDialogState = {
    open: false,
    type: ECommonDialogType.NORMAL,
    title: "Alert",
    message: "",
    buttons: [
      {
        title: "OK",
      },
    ],
  };
  componentDidMount() {
    commonDialogManager.register(this);
  }
  componentWillUnmount() {
    commonDialogManager.unregister(this);
  }

  render() {
    return (
      <Dialog
        open={this.state.open}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        maxWidth={"sm"}
        fullWidth
        sx={{ zIndex: 100000 }}
      >
        <DialogTitle
          sx={{ fontSize: "20px", fontWeight: "700" }}
          color={_getType(this.state.type).color}
        >
          {this.state.title}
        </DialogTitle>
        {(this.state.type === ECommonDialogType.NORMAL ||
          this.state.type === ECommonDialogType.WARNING) &&
          this.renderNormalSection()}
        {this.state.type === ECommonDialogType.ERROR &&
          this.renderDeleteSection()}
        <DialogActions>{this.renderButton()}</DialogActions>
      </Dialog>
    );
  }

  renderButton() {
    return this.state.buttons.map((button) => (
      <Button
        key={button.title}
        color={
          this.state.type === ECommonDialogType.ERROR && !button.isCancel
            ? "error"
            : "primary"
        }
        variant={button.isCancel ? "outlined" : "contained"}
        onClick={() => this.onPressButton(button.onClick as () => void)}
        {...button.buttonProps}
      >
        {button.title}
      </Button>
      // key={button.title}
      // title={button.title}
      // type={button.isCancel ? "clear" : "solid"}
      // style={{ marginHorizontal: 4 }}
      // containerStyle={styles.button}
      // onPress={() => this.onPressButton(button.onPress as () => void)}
    ));
  }

  renderNormalSection() {
    return (
      <DialogContent>
        {this.state.component || <Typography>{this.state.message}</Typography>}
      </DialogContent>
    );
  }

  renderDeleteSection() {
    return (
      <DialogContent>
        {this.state.component || (
          <Fragment>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Typography marginRight={"6px"}>
                {I18nTranslator(translations.masterData.uWantToDel)}
              </Typography>
              <Typography fontWeight={"700"}>{this.state.message}</Typography>
            </Box>
            <Typography color={"error"}>
              {I18nTranslator(translations.masterData.noteDel)}
            </Typography>
          </Fragment>
        )}
      </DialogContent>
    );
  }

  onPressButton(onPress: () => void) {
    this.setState({ open: false }, () => {
      onPress && onPress();
    });
  }

  openDialog(arg: IDialogArg) {
    const {
      title,
      message = "",
      type,
      disableCancel = false,
      buttons = this.state.buttons,
      component,
    } = arg;
    this.setState(
      { title, message, buttons, type, disableCancel, component },
      () => {
        this.setState({ open: true });
      }
    );
  }
  closeDialog(onClose?: () => void) {
    this.setState({ open: false }, () => {
      if (onClose) {
        onClose();
      }
    });
  }
}
